export const EPPO_EVENT_SOURCE = 'aws_firehose';

export const PROJECT = 'YGw';

export const ONGOING_EXPERIMENTS = {
    DownloadPageRedesign: 'web_app_download_page_redesign',
    ContactUsChat: 'cse-chatbot-toggle',
    OneTrustBannerEnable: 'onetrust_banner_enabled',
    DynamicProductDescriptions: 'dynamic_product_descriptions',
    CancellationQuizReasonsUpdate: 'cancellation-quiz-reasons-update',
};
